import types from "./types";
import StoreTypes from "../../../store/types";

const initialState = {
  register: {
    email: "",
  },
  redirect: "",
  user: {},
  auth: false,
  adminAuth: false,
  hasChildren: false,
  hasOtherChildren: false,
  hasPartner: false,
  hasFamily: false,
  incapacityPlan: false,
  country: "",
  state: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_HAS_CHILDREN:
      return { ...state, hasChildren: action.payload };

    case types.SET_HAS_OTHER_CHILDREN:
      return { ...state, hasOtherChildren: action.payload };

    case types.SET_HAS_PARTNER:
      return { ...state, hasPartner: action.payload };

    case types.SET_LOCATION:
      return { ...state, country: action.payload };

    case types.SET_REGISTER_EMAIL:
      return {
        ...state,
        register: { ...state.register, email: action.payload },
      };

    case types.SET_REDIRECT:
      return { ...state, redirect: action.payload };

    case types.SET_LOGGED_IN:
      return { ...state, auth: action.payload };

    case types.SET_ADMIN_LOGGED_IN:
      return { ...state, adminAuth: action.payload };

    case types.SET_USER_DETAILS:
      return { ...state, user: action.payload };

    case StoreTypes.SET_DETAILS:
      return {
        ...state,
        country: action.payload.basic?.country || state.country,
        state: action.payload.basic?.state || state.state,
        hasChildren: action.payload.basic?.hasChildren,
        hasOtherChildren: action.payload.basic?.hasOtherChildren,
        incapacityPlan: action.payload.basic?.incapacityPlan,
        hasPartner: action.payload.family?.hasPartner,
      };

    default:
      return state;
  }
};

export default reducer;
